<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row style="height: 36px">
          <el-form :inline="true" :model="searchCondition">
            <el-form-item label="姓名">
              <el-input v-model="searchCondition.fullname" placeholder="输入姓名" class="item-name" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchButton" style="color: #1890ff">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <ScreeCompany
            :allowField="allowField"
            @ScreeCompany="ScreeCompany" />
          <div class="table-right">
            <MonthPicker @MonthSearch="MonthSearch" ref="dataSelect" @remove='removePicker' />
            <el-select v-model="value" placeholder="请选择导出类型" @change="selectData" class="select-box" size="medium">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button :loading="downloadLoading" style="margin:0 0 20px 20px;" type="primary" size="medium" icon="el-icon-document" @click="handleDownload" >
              导出
            </el-button>
          </div>
        </el-row>
        <!-- 生成签约链接的dialog模态框 -->
        <el-dialog title="生成合作邀请码"
        :visible.sync="outerVisible"
        :before-close="handleOuterClose"
         width="40%">
          <el-form :inline="true" :model="searchCondition">
            <el-form-item label="请选择任务类型" prop="desc" id="desc">
              <el-checkbox-group v-model="companyFormData.name" size="small" @change="handleTaskChange">
                <el-checkbox
                  v-for="item in categoryList"
                  :label="item.name"
                  :key="item.id"
                  border>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <el-dialog
            width="40%"
            :title="'系统提示'"
            :close-on-click-modal="false"
            :visible.sync="innerVisible"
            :before-close="handleInnerClose"
            append-to-body>
            <div class="dialog-title">
              <i class="el-icon-success" style="font-size: 40px; color: #409eff;"></i>
              <span class="title-text">手机扫一扫，请到手机端分享</span>
            </div>
            <div class="center-box">
              <img :src="this.OrImage" class="QR-code" v-if="this.OrImage"/>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="closeQRDialog" size="medium" :disabled="isCheck">关闭</el-button>
            </div>
          </el-dialog>
          <div slot="footer" class="dialog-footer" style="text-align: center; margin-bottom: 20px">
            <el-button type="primary" @click="checkCategory" size="medium" :disabled="isCheck">生成合作邀请码</el-button>
          </div>
        </el-dialog>

        <el-dialog title="PDF列表" :visible.sync="dialogMultPdf" width="30%">
          <div class="mainPDF" :key="index" v-for="(item, index) in dialogPdfArr">
            <label>{{ item.sign_name }}</label>
            <img
              @click="goPage(item)"
              style="width: 60px; height: auto; cursor: pointer"
              src="https://xl-online.oss-cn-hangzhou.aliyuncs.com/xladmin/static/icon_pdf.png"
            />
          </div>
        </el-dialog>

        <ApeTable ref="apeTable" :data="companyList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            v-if="buttonType=='text'"
            width="220"
            header_align='center'
            align='center'
            label="操作">
            <template slot-scope="scope">
              <span>
                <el-button v-if="userPermissions.includes('customer_edit')" size="mini" type="primary" @click="updateContract(scope.row.id,scope.row.customers_id)">编辑</el-button>
                <el-button size="mini" type="default" @click="viewButton(scope.row.id)">详情</el-button>
                <el-button :disabled="!scope.row.sign_url" v-if="userPermissions.includes('customer_agreement')" size="mini" type="primary" plain @click="showXY(scope)">查看协议</el-button>
                <el-popover
                  placement="top"
                  width="150"
                  v-model="scope.row.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'
import { mapGetters, mapState} from 'vuex'
import ScreeCompany from '@/components/ScreeCompany.vue'
import MonthPicker from '@/components/MonthPicker.vue'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    ScreeCompany,
    MonthPicker
  },
  data() {
    return {
      dialogPdfArr: [],
      dialogMultPdf: false,
      checkList: ['选中且禁用','复选框 A'],
      companyFormData: {
        category_id: [],
        name: []
      },
      categoryList: [],
      signUrl: '',//签约链接
      outerVisible: false,//外层模态框状态
      innerVisible: false,//内层模态框状态
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: true,
      columns: [
        {
          title: 'ID',
          value: 'id',
          width: 170,
          header_align: 'center',
          align: 'center',
        },
        {
          title: '姓名',
          width: 200,
          header_align: 'center',
          value: [
            {label:'姓名：',value:'fullname'},
            {label:'性别：',value:'alias_sex'},
            {label:'生日：',value:'birthday'},
            {label:'qq：',value:'qq'},
            {label:'手机号码：',value:'mobile'},
          ],
        },
        {
          title: '证件号码',
          value: 'id_number',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '服务类型',
          value: 'category_name',
          header_align: 'center',
          align: 'center',
        },
        // {
        //   title: '身份证正面照片',
        //   header_align: 'center',
        //   align: 'center',
        //   type: 'image',
        //   value: 'id_img_positive',
        // },
        //  {
        //   title: '身份证反面照片',
        //   type: 'image',
        //   value: 'id_img_back',
        //   header_align: 'center',
        //   align: 'center',
        // },
        {
          title: '创建时间',
          value: 'created_at',
          header_align: 'center',
          align: 'center',
         /*  width: 180 */
        },
      ],
      // 表格列表数据
      companyList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        title: '',
        width_height: '640px',
        show_footer:false,
      },
      // 附件列表
      attachmentList:[],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: '标题',
          value: 'title',
        }
      ],
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentCompanyId:0,
      isCheck: true,//是否禁用确定按钮
      category_Id: '',
      category_name: '',
      id: '',
      OrImage: '',
      is_import: '',
      options: [{
          value: 'xlsx',
          label: 'xlsx'
        }, {
          value: 'csv',
          label: 'csv'
        }, {
          value: 'txt',
          label: 'txt'
        }
      ],
      value: 'xlsx',
      bookType: 'xlsx',//导出表格类型
      downloadLoading: false,
      // 允许显示的字段
      allowField: ['companyId', 'settlementId'],
    }
  },

  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    removePicker(){
      this.searchCondition.start_time=''
      this.searchCondition.end_time=''
    },
    goPage(e) {
      this.mxPreview(e.sign_url);
    },
    //查看协议
    async showXY(e) {
      let surl = "";
      if(e.row?.sign_detail){
        if(e.row?.sign_detail.length>1){
          this.dialogPdfArr = e.row.sign_detail;
          this.dialogMultPdf = !this.dialogMultPdf;
          return false;
        }else if(e.row?.sign_detail?.length == 1){
          surl = e.row.sign_detail[0].sign_url;
        }else {
          surl = e.row.sign_url;
        }
      }

      if (e.row.sign_status == 2) {
        let { id } = e.row;
        let param = {};
        param.id = id;
        console.log(param, "结果");
        let result = await this.$api.getQZinfo(param);
        console.log(result);
        let qzId = result;

        console.log(qzId);

        let str = "/pages/sign/draw";
        if (this.$config.domain.miniappPath) {
          str = this.$config.domain.miniappPath;
        }
        let path = `${str}?id=${qzId}`;
        let args = {
          path: path,
          appId: this.mxDomain.appId,
          id: id, //11/18传入
        };
        let res = await this.$api.createQrcode(args);
        if (res) {
          this.OrImage_qz = res;
          this.qzFlag = true;
        }
        return false;
      }
	const whiteList=['openapi','import',"esign","receive_api" ]
      if (whiteList.includes(e.row.sign_type) ){
        this.mxPreview(e.row.sign_url);
      }else if(!e.row.sign_url && e.row.contract_url) {
          this.mxPreview(e.row.contract_url);
      }else {
          this.htmlToPdf(
            surl,
            e.row.sign_type,
            e.row.id
          );
      }
      
    },
    htmlToPdf(
      sign_url,
      sign_type,
      id
    ) {
      if (sign_type == "esign") {
        this.mxPreview(sign_url);
      } else {
        let routeData = this.$router.resolve({
          path: "/customer/exportpdf",
          query: {id},
        });
        window.open(routeData.href, "_blank");
      }
    },

    //导出
    async handleDownload() {
      this.isExport = true;
      this.downloadLoading = true
      let list = await this.init('export')
      import('@/excel/Export2Excel').then( excel => {
        const tHeader = ['ID','姓名','性别','生日','qq','手机号码','证件号码', '服务类型', '身份正面照片', '身份反面照片', '创建时间',];
        const data = this.formatJson(list)
        const time = new Date().getTime() + Math.random() * 1000
        let filename = `人才签约${time}`
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType //Optional
        })
        this.downloadLoading = false;
      })
    },
    //转换导出数据
    formatJson(jsonData) {
      return jsonData.map(v =>{
        let {
          id,
          fullname,
          alias_sex,
          birthday,
          qq,
          mobile,
          id_number,
          category_name,
          id_img_positive,
          id_img_back,
          created_at
        } = v
        return [ id,fullname,alias_sex,birthday,qq,mobile,id_number,category_name,id_img_positive,id_img_back,created_at]
      })
    },
    //选择导出类型
    selectData(e) {
      this.bookType = e;
    },
    // 导出日期
    MonthSearch(v) {
      if (v) {
        this.searchCondition.start_time = v[0]
        this.searchCondition.end_time = v[1]
      }
      this.init('search')
    },
    ScreeCompany(v, name) {
      if(name == 'company') {
        if (v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }
      if(name == 'settlement') {
        if (v) {
          this.searchCondition.channel_account = v
        } else {
          delete this.searchCondition.channel_account
        }
        this.init('search')
      }
    },
    //获取支持批量人才状态
    async isImport() {
      let args = {
        companyId: this.$route.params.company_id
      }
      let result = await this.$api.isImport(args)
      if(result) {
        this.is_import = result.is_import
        console.log("this.is_import", this.is_import)
      }
    },
    //关闭二维码弹窗
    closeQRDialog() {
      this.outerVisible = false
      this.innerVisible = false
      this.companyFormData = {
        category_id: [],
        name: []
      };
    },
    //复选框选择时间
    handleTaskChange(val) {
      if(val) {
        this.isCheck = false
        this.categoryList.find((value) => {
          this.companyFormData.name.forEach((item, index) => {
            if(item == value.name) {
              this.companyFormData.name[index] = value.name
              this.companyFormData.category_id[index] = value.id
            }
          })
        });
        this.category_Id = this.companyFormData.category_id.join("、")
        this.category_name = this.companyFormData.name.join("、")
        const { company_id, settlement_id } = this.userInfo
        this.signUrl = encodeURI(`${this.$config.uniBaseURL}#/pages/sign/login?companyId=${company_id}&settlementId=${settlement_id}&categoryId=${this.category_Id}&categoryName=${this.category_name}&location=${this.mxDomain.location}`)
      }
    },
    //获取签约链接
    async cusomerLink() {
      this.categoryList = await this.$api.getCustomerCategoryList()
      this.outerVisible = true;
    },
    //关闭内层小dialog×
    handleInnerClose() {
      this.innerVisible = false;
    },
    //关闭外层dialog小×
    handleOuterClose() {
      this.outerVisible = false;
      this.companyFormData = {
        category_id: [],
        name: []
      };
    },
    //取消内层dialog
    innerClose() {
      this.innerVisible = false;
    },
    checkCategory() {
      if(this.companyFormData.category_id != ''){
        this.getQRCode()
      }
    },
    // 创建二维码
    async createQrCode(id) {
      let path = `pages/mission/detail?id=${id}&companyId=${this.mxCompanyId}&settlementId=${this.mxSettlementId}`
      let args = {
        path: path,
        appId: this.mxDomain.appId
      }
      let res = await this.$api.createQrcode(args)
      if (res) {
        this.OrImage = res
      }
    },
    async getQRCode() {
      let nameList = [], names,remark, name
      this.companyFormData.name.forEach((item) => {
       nameList.push(item.substring(0,item.length-2))
      })
      names = nameList.join("、")
      name = `${names}`
      remark = `因委托方业务发展，现需要若干有相关服务经验或能力的自由职业者提供${this.companyFormData.name.join("、")}，具体要求和费用由委托方公布。`
      let args = {
        name,
        remark,
        category_id: this.companyFormData.category_id.join("、"),
        category_name: this.companyFormData.name.join("、")
      }
      let res = await this.$api.getQRCode(args)
      if(res) {
        this.innerVisible = true
        this.createQrCode(res)
      }
    },

    // 搜索
    searchButton() {
      this.init('search')
    },
    //导入跳转
    importExcel() {
      this.$router.push({path: 'customer/import'})
    },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    // 响应添加按钮
    async addButton() {
      // this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id)
      this.$router.push(this.$route.path+'/'+id+'/view')
    },
	updateContract(id,customers_id){
		this.$router.push({path: this.$route.path+'/'+id+'/view', query: {update: true,customers_id,pid:id}})
	},
    // 响应编辑按钮
    async editButton(id) {
      console.log(id)
      // this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      console.log(id)
      let info = await this.$api.deleteCustomer(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.init('del')
        })
      } else {
        this.$message.error(info)
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      console.log();
      if(value == null ){
        let time = this.$refs.dataSelect.value
        this.searchCondition.start_time = time[0]
        this.searchCondition.end_time = time[1]
        return
      }
      this.searchCondition.start_time = value[0]
      this.searchCondition.end_time = value[1]
    },
    replaceStr(str) {
      const middleValue = str.substring(4,14)
      return str = `****${middleValue}****`
    },
    // // 导出表格-分每次1000+页码切换
    // async exportExcel(){
    //   let pagingInfo = { 
    //     current_page:1,
    //     page_size:1000
    //   }
    //   let res = await this.$api.getCustomerList(pagingInfo)
    //   let {data} = await this.$api.getCustomerList(pagingInfo)

    //   let arr = res.data.push(...data)

    //   console.log(arr)

    // },
    // 初始化列表
    async init(type) {
      let pagingInfo = this.$refs['apeTable']?.getPagingInfo(type) || {current_page:1,page_size:10}
      if (type == 'export') {
        pagingInfo.page_size = 50000
        console.log(pagingInfo,'页面对象')
      } else {
        this.loadingStaus=true
      }
      if(type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {data, pages} = await this.$api.getCustomerList(searchCondition)
      data = data.filter((item) => {
        // return item.id_number = item.id_number.replace(/([\d]{4})\d{10}([\d]|[\s]{4})/, '$1*********$2')
        item.id_number = this.replaceStr(item.id_number)
        return item
      })
      if (type == 'export') {
        return data
      } else {
        this.companyList = []
        this.$nextTick(() => {
          this.companyList=data
        })
        this.pagingData.total = pages.total
        console.log(this.pagingData.total,'总数')
        this.offset = pages.offset
        this.loadingStaus=false
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.fullname) {
        condition.fullname = this.searchCondition.fullname
      }
      if (this.searchCondition.sign_type) {
        condition.sign_type = this.searchCondition.sign_type
      }
      if (this.searchCondition.start_time) {
        condition.start_time = this.searchCondition.start_time
      }
      if (this.searchCondition.end_time) {
        condition.end_time = this.searchCondition.end_time
      }
      if (this.searchCondition.company_id) {
        condition.company_id = this.searchCondition.company_id
      }
      if (this.searchCondition.channel_account) {
        condition.channel_account = this.searchCondition.channel_account
      }
      return condition
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      this.formData.company_id = this.currentCompanyId
      let id = await this.$api.saveCompanyAttachment(this.formData)
      this.$nextTick(() => {
        this.dialogClose()
      })
      this.$nextTick(() => {
        if (id) {
          this.initCompanyAttachmentList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.attachmentUploadFileList = []
    },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true
      this.dialogData.loading = false
      this.dialogData.title = '添加附件'
    },
    // 相应删除文章附件按钮
    async deleteCompanyAttachmentButton(id) {
      let info = await this.$api.deleteCompanyAttachment(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initCompanyAttachmentList()
        })
      } else {
        this.$message.error(info)
      }

    },
    keyupSubmit(){
      document.onkeydown = e => {
        console.log(e)
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },
  created() {
    // let { company_id, settlement_id } = this.userInfo
    this.keyupSubmit()
  },
  mounted() {
    this.init()
    // this.exportExcel()
    // this.isImport()
  },
}
</script>

<style lang="stylus" scoped>
.mainPDF {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.mainPDF label {
  margin-bottom: 10px;
}

  /deep/.el-checkbox-group label
    width: 180px
  /deep/.el-checkbox-group label:first-child
    margin-left: 10px
  /deep/.el-checkbox-group
    // width: 660px
  .el-button
    margin-right 4px
    margin-bottom 4px
  .item-name
    width: 130px
  .table-header-gai
    height: 35px
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .returnBtn
    position: relative
    top: 10px
    float: right
  .table-right
    float right
  .submitBtn
    float right
    margin-top: 20px
  .link-url
    color: #fff
    text-decoration:none
  .cusomer-link-gai
    position: absolute;
    top: 0
    font-size: 15px
    width: 160px
  .cusomer-link
    position: absolute;
    top: 0
    right: 0
  .total-num
    position: absolute;
    top: 0
    right: 0
    line-height: 40px
    padding-right: 20px
  .span-num
    color: #f00
  .selectWord
    width: 150px
  .link-title
    text-align: center
    padding-bottom: 10px
    color: red
  .people-btn-wrapper
    margin-top:20px
  .dialog-title
    display: flex
    justify-content: center
    align-items: center;
    margin-bottom: 20px
    margin-top: -20px
  .title-text
    font-size: 20px
    margin-left: 10px
  .center-box
    display: flex
    justify-content: center
    align-item: center
    padding: 30px 0
  .QR-code
    width: 150px
    height: 150px
  .main-page-content
    position: relative

</style>
